<div class="flex flex-col fill">
  <mic-header>
    <div class="flex flex-row items-center justify-between">
      <div class="flex flex-row flex-none items-center">
        <mic-sidebar-toggler [alwaysDisplay]="true" id="main-sidebar-toggler" type="left"></mic-sidebar-toggler>
        <a routerLink="/">
          <mic-logo></mic-logo>
        </a>
      </div>
      <mic-navbar-spacer></mic-navbar-spacer>
      <span class="title md-hidden">{{ title }}</span>
      <mic-navbar-spacer></mic-navbar-spacer>
      <div class="flex flex-row flex-none gap-2 items-center">
        <mic-navbar-links *ngIf="userClaims && !isMobileScreen">
          <mic-navbar-link
            link="/user"
            [label]="userClaims.fullname"
            [alignRight]="true"
          ></mic-navbar-link>
        </mic-navbar-links>
        <mic-navbar-spacer fxFlex="1"></mic-navbar-spacer>
        <div (click)="authWrapperService.isAuthenticated() ? logout() : login()">
          <mic-navbar-links>
            <mic-navbar-link
              [link]="null"
              [label]="authWrapperService.isAuthenticated() ? 'Logout' : 'Login'"
              [icon]="authWrapperService.isAuthenticated() ? 'logout' : 'vpn_key'"
              icon="login"
            ></mic-navbar-link>
          </mic-navbar-links>
        </div>
        <button mat-icon-button class="mic-icon-button-medium" aria-label="Set theme" (click)="setTheme()">
          <mat-icon [fontIcon]="darkMode ? 'light_mode' : 'bedtime' "></mat-icon>
        </button>
      </div>
    </div>
  </mic-header>
  <mic-sidebar-container leftToggler="main-sidebar-toggler">
    <mic-sidebar position="start">
        <mic-sidebar-item icon="insert_drive_file" label="Informes">
          <mic-sidebar-item link="ppse/accounting-bag-contribution" label="Aportaciones Anuales al Plan de Previsión Social Empresarial (Boletín)"></mic-sidebar-item>
          <mic-sidebar-item link="bs/business-loan" label="Certificado de Préstamo de Vivienda"></mic-sidebar-item>
          <mic-sidebar-item link="basic/total-remuneration" label="Remuneración Total"></mic-sidebar-item>
        </mic-sidebar-item>
        <mic-sidebar-item icon="school" label="Beneficios Sociales">
          <mic-sidebar-item link="bs/requests-colony-help" label="Solicitudes de Ayudas de Colonias"></mic-sidebar-item>
        </mic-sidebar-item>
        <!-- <mic-sidebar-item icon="add_to_photos" label="Beneficios Sociales">
          <mic-sidebar-item link="bs/requests-colony-help" label="Solicitudes de Ayudas de Colonias"></mic-sidebar-item>
        </mic-sidebar-item>
        <mic-sidebar-item icon="create_new_folder" label="Beneficios Sociales">
          <mic-sidebar-item link="bs/requests-colony-help" label="Solicitudes de Ayudas de Colonias"></mic-sidebar-item>
        </mic-sidebar-item>        
        <mic-sidebar-item icon="add_circle" label="Beneficios Sociales">
          <mic-sidebar-item link="bs/requests-colony-help" label="Solicitudes de Ayudas de Colonias"></mic-sidebar-item>
        </mic-sidebar-item> -->
    </mic-sidebar>
    <mic-main-content main>
      <div class="flex flex-col fill justify-between" content>
        <div class="sidebar-container-content">
          <router-outlet></router-outlet>
        </div>
        <mic-footer>
          <div class="xs-self-center"></div>
          <div class="xs-self-center">Copyright Michelin © {{ year }}</div>
          <div class="version xs-self-center">Version {{ version }}</div>
        </mic-footer>
      </div>
    </mic-main-content>
  </mic-sidebar-container>

  <mic-alert-center [hideDelay]="8"></mic-alert-center>
</div>
